import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo sé que es original?',
  answer: 'Cada gorra pertenece a una serie única de 100 piezas. Una vez agotadas, el diseño se retira de producción.'
}, {
  question: '¿Cuál es el tiempo de entrega?',
  answer: 'Procesamos tu orden en 24h. Recibe tu corona en la puerta de tu casa de 2 a 5 días hábiles.'
}, {
  question: '¿Tienen garantía?',
  answer: 'Calidad garantizada. Si el bordado o los acabados no son de nivel premium, te devolvemos tu dinero.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-[#0A0A0A] py-20 px-4" data-id="element-13">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto" data-id="element-14">
        <h2 className="font-bebas text-5xl md:text-6xl text-white text-center mb-12 tracking-wider" data-id="element-15">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-16">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gray-800 overflow-hidden" data-id="element-17">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-900 transition-colors" data-id="element-18">
                <span className="font-bebas text-2xl md:text-3xl text-white tracking-wide" data-id="element-19">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-misery-magenta transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-20" />
              </button>
              {openIndex === index && <div className="px-6 pb-6" data-id="element-21">
                  <p className="font-inter text-gray-300 leading-relaxed" data-id="element-22">
                    {faq.answer}
                  </p>
                </div>}
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}